import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {BuyFeatureView} from '@gongxigames/framework/slot/modules/buyFeature/BuyFeatureView';
import {BuyFeatureModule} from '@gongxigames/framework/slot/modules/buyFeature/BuyFeatureModule';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow/FlowModuleEvents';
import {UIDisableReason} from '@gongxigames/framework/slot/modules/keypad/UIDisableReason';
import {BuyFeatureStates} from '@gongxigames/framework/slot/modules/buyFeature/BuyFeatureStates';

export class BuyFeatureFeatureState extends ModuleState<BuyFeatureView, BuyFeatureModule> {
    public onEnterState(): void {
        this.view.toggleShowButton(false);
    }

    public onLeaveState(): void {
        this.module.enableShowPopupButtonByName(UIDisableReason.TRIGGERING_FEATURE);
        this.view.toggleShowButton(true);
    }

    protected setupEvents(): void {
        this.setEventHandler(FlowModuleEvents.ENTER_BASIC_STATE, this.checkIfSpinNext.bind(this));
        this.setEventHandler('General.Popups.Add', this.onShowPopup.bind(this));
    }

    protected onShowPopup(): void {
        this.view.onCancelButtonPointerUp();
    }

    protected checkIfSpinNext(): void {
        if (this.module.logic.nextActionIsSpin()) {
            this.module.gotoState(BuyFeatureStates.BASIC);
        }
    }
}
